import React from 'react';
import { motion } from 'framer-motion';
import { Plane, Phone, MessageCircle } from 'lucide-react';
export function CtaBanner() {
  return <section className="pt-12 pb-24 bg-gradient-to-b from-navy to-black relative border-b border-white/5 overflow-hidden" data-id="element-192">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-gold/5 blur-[100px] rounded-full pointer-events-none" data-id="element-193"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-194">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="w-20 h-20 mx-auto bg-navy-light rounded-full flex items-center justify-center mb-8 border border-gold/30 shadow-gold-glow" data-id="element-195">
          <Plane className="w-10 h-10 text-gold transform -rotate-45" data-id="element-196" />
        </motion.div>

        <motion.h2 initial={{
        y: 20,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-4xl md:text-6xl font-heading font-bold text-white mb-6 uppercase tracking-tight" data-id="element-197">
          AOG? We Are Ready <span className="text-gold" data-id="element-198">Right Now.</span>
        </motion.h2>

        <motion.p initial={{
        y: 20,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-199">
          24/7 dispatch available. Time-critical deliveries across the US. Call
          or text us anytime.
        </motion.p>

        <motion.div initial={{
        y: 20,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-200">
          <a href="tel:+17862620064" className="w-full sm:w-auto flex items-center justify-center bg-gold hover:bg-gold-light text-navy font-bold py-4 px-8 rounded-full transition-all shadow-gold-glow hover:shadow-gold-glow-lg transform hover:-translate-y-1 text-lg" data-id="element-201">
            <Phone className="w-5 h-5 mr-2" data-id="element-202" />
            Call +1 786-262-0064
          </a>
          <a href="https://wa.me/17862620064" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center bg-transparent hover:bg-white/5 text-white border-2 border-white font-bold py-3.5 px-8 rounded-full transition-all text-lg" data-id="element-203">
            <MessageCircle className="w-5 h-5 mr-2" data-id="element-204" />
            Send a WhatsApp
          </a>
        </motion.div>
      </div>
    </section>;
}